<template lang="pug">
  .basic-info
    header-info
    brief-info

</template>

<script>
// TODO: 应该跨view组件引用吗
import HeaderInfo from '@/umcc/views/VendorInfo/components/HeaderInfo'
import BriefInfo from '@/umcc/views/VendorInfo/children/BasicInfo/children/BriefInfo'

export default {
  components: {
    HeaderInfo,
    BriefInfo
  },
  beforeMount () {
    this.$store.commit('vendor/setId', this.$store.state.common.user.struct_group_id)
  }
}
</script>
